<template>
  <div class="overlay" v-if="mostrar">
    <div class="modal-content">
      <div class="modal-header">
        <span class="modal-label">Editar Sigla</span>
        <button class="btn-fechar-modal" @click="fechar">
          × </button>
      </div>
      <div class="modal-body" v-if="verificando">
        <p>Verificando permissões...</p>
      </div>
      <div class="modal-body" v-else-if="!ehCoordenador">
        <p>Apenas o coordenador da ação pode alterar a sigla.</p>
        <button class="btn-salvar" @click="fechar" style="margin-top: 15px">
          Ok
        </button>
      </div>
      <div class="modal-body" v-else>
        <div class="form-group">
          <label>Sigla da Ação (Máximo 10 caracteres)</label>
          <input type="text" v-model="sigla" maxlength="10" placeholder="Ex: EXT2024" class="input-estilizado" />
        </div>
        <div class="form-group">
          <label>Cor da Sigla</label>
          <div style="display: flex; gap: 10px; align-items: center">
            <input type="color" v-model="cor" class="input-cor" />
            <span>{{ cor }}</span>
          </div>
        </div>
        <div class="modal-actions">
          <button class="btn-cancelar" @click="fechar">
            Cancelar
          </button>
          <button class="btn-salvar" @click="salvar" :disabled="salvando">
            {{ salvando ? "Salvando..." : "Salvar" }}
          </button>
        </div>
      </div>
    </div>
    <Aviso v-if="aviso.mostrar" :sucesso="aviso.sucesso" :texto="aviso.mensagem" @fecharModal="aviso.mostrar = false" />
  </div>
  <ModalAviso v-if="mostrarAviso" :sucesso="avisoSucesso" :texto="textoAviso" @fecharModal="fecharAviso" />
</template>


<script setup>
import { ref, reactive, watch } from "vue";
import acaoService from "@/service/acaoService";
import ModalAviso from "@/components/common/aviso.vue";

const props = defineProps({
  mostrar: Boolean,
  acaoId: [String, Number],
  siglaAtual: String,
  corAtual: String,
});

const emit = defineEmits(["fechar", "atualizado"]);

const verificando = ref(true);
const ehCoordenador = ref(false);
const salvando = ref(false);
const aviso = reactive({
  mostrar: false,
  sucesso: false,
  mensagem: "",
});

const sigla = ref(props.siglaAtual || "");
const cor = ref(props.corAtual || "#482a89");

const mostrarAviso = ref(false);
const avisoSucesso = ref(false);
const textoAviso = ref("");
const fecharAposAviso = ref(false);

watch(
  () => props.mostrar,
  async (newMostrar) => {
    if (newMostrar && props.acaoId) {
      sigla.value = props.siglaAtual || "";
      cor.value = props.corAtual || "#482a89";

      try {
        verificando.value = true;
        const response = await acaoService.verificarCoordenador(
          props.acaoId
        );
        ehCoordenador.value = !!response;
      } catch (error) {
        console.error(error);
        ehCoordenador.value = false;

        exibirAviso(
          "Não foi possível verificar suas permissões. Tente novamente.",
          false
        );
      } finally {
        verificando.value = false;
      }
    }
  },
  { immediate: true }
);

function fechar() {
  emit("fechar");
}

function exibirAviso(texto, sucesso, fecharDepois = false) {
  textoAviso.value = texto;
  avisoSucesso.value = sucesso;
  fecharAposAviso.value = fecharDepois;
  mostrarAviso.value = true;
}

function fecharAviso() {
  mostrarAviso.value = false;

  if (fecharAposAviso.value) {
    fecharAposAviso.value = false;
    fechar();
  }
}

async function salvar() {
  if (!sigla.value.trim()) {
    exibirAviso("A sigla não pode ser vazia.", false);

    return;
  }

  if (sigla.value.length > 10) {
    exibirAviso(
      "A sigla deve ter no máximo 10 caracteres.",
      false
    );
    return;
  }

  try {
    salvando.value = true;

    if (
      sigla.value !== props.siglaAtual ||
      cor.value !== props.corAtual
    ) {
      await acaoService.editarSigla(
        props.acaoId,
        sigla.value,
        cor.value
      );
    }
    emit("atualizado", {
      sigla: sigla.value,
      corSigla: cor.value,
    });

    exibirAviso(
      "Configurações atualizadas com sucesso!",
      true,
      true
    );
  } catch (error) {
    console.error(error);

    exibirAviso(
      "Erro ao atualizar a sigla. Verifique se você tem permissão e tente novamente.",
      false
    );

  } finally {
    salvando.value = false;
  }
}
</script>


<style scoped>
.modal-content {
  border-radius: 8px;
  width: 90%;
  max-width: 400px;
  box-shadow: 0 4px 6px hsla(0, 0%, 0%, 0.1);
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.modal-body {
  padding: 1rem;
  background-color: var(--branco);
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.form-group label {
  font-weight: 500;
  color: var(--preto);
}

.input-estilizado {
  padding: 10px;
  border: 1px solid var(--cinza-medio);
  border-radius: 4px;
  font-size: 1rem;
}

.input-cor {
  width: 50px;
  height: 40px;
  padding: 0;
  border: none;
  cursor: pointer;
  border-radius: 4px;
}

.modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 20px;
}

.btn-cancelar {
  background: var(--vermelho-escuro);
  color: var(--branco);
  border: none;
  border-radius: 10px;
  padding: 8px 28px;
  font-weight: 600;
  cursor: pointer;
  font-size: 0.9rem;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);

}

.btn-cancelar:hover {
  background: var(--vermelho);


}

.btn-salvar {
  background: var(--roxo-primario);
  color: var(--branco);
  border: none;
  border-radius: 10px;
  padding: 8px 28px;
  font-weight: 600;
  cursor: pointer;
  font-size: 0.9rem;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);

}

.btn-salvar:hover {
  background: var(--roxo-medio);


}


.btn-salvar:disabled {
  background-color: var(--roxo-medio);
  cursor: not-allowed;
}
</style>
